import React, { useContext, useEffect, useState } from 'react'
import { CloseChatContext } from './ComplateMessages'

function ChatHeader() {
    const { state, dispatch } = useContext(CloseChatContext)

    const initialState = (
        <div className="col-6">
            <h4></h4>
            <div className="ticket-info"></div>
        </div>
    )
    const [renderHeader, setrenderHeader] = useState(initialState)
    useEffect(() => {
        if (state.active != null) {
            const chat = state.chats.find(chat => chat.id == state.active)
            setrenderHeader(
                <div className="col-6">
                    <h4 style={{ fontWeight: 'bolder' }}>{`${chat.profile.id} - ${chat.username}`}</h4>
                    <div className="ticket-info">Topic : {chat.category.name}</div>
                </div>
            )
        } else {
            setrenderHeader(initialState)
        }
    }, [state.active])
    return (
        <div className="card-header" style={{ backgroundColor: '#fff' }}>
            <div className="ticket-header col-12 pt-1">
                <div className="ticket-sender-picture p-1 m-0 col-auto">
                    {state.active != null ? (<img src="../assets/img/avatar/avatar-5.png" width="70px" alt="image" />) : ''}
                </div>
                <div className="ticket-detail col-11 pt-0 pb-0 mt-0 mb-0">
                    <div className="row justify-content-between pt-1">
                        {renderHeader}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ChatHeader
